// @ts-nocheck
// Pure rules for the paid shopping list. No DOM.
// Ingredient names are free text (zutat metaobjects, own recipes), so everything here works on the name
// (+ unit for herbs): one merge key per ingredient, the supermarket aisle it belongs to, and whether it is
// a pantry staple most people already have (Vorrat). Unknown names land in "Sonstiges", never dropped,
// except plain water and ice.
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.vhpPlannerShopRules = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  // Copy from snippets/vhp-i18n.liquid in the browser; the German default in node (tests).
  const T = (key, de, vars) => {
    const all = globalThis.vhpI18n;
    if (globalThis.vhpT && all && key in all) return globalThis.vhpT(key, vars);
    return vars ? de.replace(/\{(\w+)\}/g, (m, name) => (vars[name] == null ? '' : String(vars[name]))) : de;
  };

  // Rough walk through a German supermarket.
  const AISLES = [
    { id: 'produce', label: T('shop.produce', "Obst & Gemüse") },
    { id: 'chilled', label: T('shop.chilled', "Kühlregal & Pflanzendrinks") },
    { id: 'dry', label: T('shop.dry', "Nudeln, Reis & Brot") },
    { id: 'cans', label: T('shop.cans', "Konserven & Gläser") },
    { id: 'sauces', label: T('shop.sauces', "Saucen, Öle & Essig") },
    { id: 'nuts', label: T('shop.nuts', "Nüsse, Saaten & Protein") },
    { id: 'frozen', label: T('shop.frozen', "Tiefkühl") },
    { id: 'spices', label: T('shop.spices', "Gewürze & Backzutaten") },
    { id: 'other', label: T('shop.other', "Sonstiges") },
  ];

  // Lowercase, hyphens/slashes as spaces, single spaces. Base for matching.
  const plain = (name) =>
    String(name || '')
      .toLocaleLowerCase('de')
      .replace(/[-/]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  // Words in front of a name that don't change what you buy.
  const LEAD_RE = /^(frische?[nrs]?|große?[nrs]?|kleine?[nrs]?|festkochende?[nrs]?|gegarte?[nrs]?)\s+/;

  // One key per ingredient: "Knoblauchzehen" = "Knoblauchzehe", "Sojasoße" = "Sojasauce",
  // "Cherry Tomaten" = "Cherrytomaten", "frische Petersilie" = "Petersilie". Only used to merge, never shown.
  const canonical = (name) => {
    let text = plain(name);
    while (LEAD_RE.test(text)) text = text.replace(LEAD_RE, '');
    return text
      .replace(/soßen?/g, 'sauce')
      .replace(/sossen?/g, 'sauce')
      .split(' ')
      .map((word) => (word.length > 4 && /(e|l)n$/.test(word) ? word.slice(0, -1) : word))
      .join('');
  };

  // Not bought: tap water (incl. pasta / cooking water) and ice. Pickle water comes from the jar → stays.
  const DROP_RE = /^(warmes |kaltes |heißes |lauwarmes )?(wasser|pastawasser|nudelwasser|kochwasser|eiswürfel)$/;
  const isDropped = (name) => DROP_RE.test(plain(name));

  // Fresh herbs are produce; these are usually dried unless the unit says otherwise (Zweig, Bund, g).
  const DRIED_HERBS_RE = /^(thymian|oregano|rosmarin|majoran|salbei|lorbeerbl[aä]tt(er)?|lorbeer)$/;
  const FRESH_UNIT_RE = /^(zweig|zweige|bund|g|stiel|stiele|handvoll|blatt|blätter)$/;

  // First match wins. Patterns run on plain(name).
  const RULES = [
    // Specific names first: they contain words the generic rules below would catch
    // ("gehackte" → hack, "Gewürzgurke" → gewürz, "Kokosmilch" → milch, "Austernpilze" → austern, …).
    ['other', /malzbier|ingwershot/],
    ['cans', /gewürzgurke|gurkenwasser|gehackte tomaten|passierte tomaten|kokosmilch|apfelmus/],
    ['dry', /sojagranulat|soja ?chunks|sojageschnetzeltes|vegane chunks|soja ?schnetzel|reispapier/],
    ['nuts', /proteinpulver|erdnussbutter|seitan ?pulver|weizengluten|hefeflocken/],
    ['spices', /pommesgewürz|gewürz|pulver|granulat|salz|pfeffer(körner)?$|^pfeffer|räucherpaprika|geräucherte paprika|garam masala|kurkuma|curry$|zimt|muskat|kreuzkümmel|kümmel|cumin|koriandersaat|sumac|sumach|piment|sternanis|anisstern|kardamom|wacholder|chili ?flocken|chiliflocken|kala namak|stärke|backpulver|natron|zucker|brühe|bouillon|vanille|liquid smoke|hefe$/],
    ['produce', /pilz|seitling|champignon|granatapfel/],
    ['sauces', /mayo|mayonnaise|essig|balsamico|öl$|^öl|kokosfett|dressing/],
    ['frozen', /(^|\s)tk(\s|$)|tiefkühl|gyoza|^pommes|wok gemüse|edamame|^erbsen$/],
    // Plant milks, tofu, alternatives, fresh pasta and dough.
    ['chilled', /tofu|tempeh|seitan|hack|chicken|hähnchen|schinken|speck|salami|krakauer|landjäger|frikadelle|steak|döner|bolognese|skyr|joghurt|quark|sahne|creme|crème|cuisine|schmand|frischkäse|käse|cheddar|parmesan|feto|butter$|vegane butter|margarine|milch|drink|mayo|mayonnaise|gnocchi|tortellini|maultaschen|spätzle|pizzateig|blätterteig|miso/],
    ['nuts', /nüsse|nuss$|nüssen|cashew|mandel|walnu|haselnu|erdnüsse|pinienkerne|sesam$|^sesam|leinsamen|chiasamen|kerne|saaten|mus$|erdnussbutter/],
    ['dry', /nudel|pasta|spaghetti|fusilli|penne|udon|cannelloni|lasagne|reis$|^reis|reisnudel|reispapier|couscous|bulgur|quinoa|haferflocken|hafer|mehl|panko|paniermehl|semmelbrösel|cornflakes|linsen|toast|brot|brötchen|wrap|tortilla|dürüm|chips|röstzwiebeln/],
    ['cans', /gehackte tomaten|passierte tomaten|tomatenmark|tomatensauce|getrocknete tomaten|kichererbsen|bohnen|kidney|mais$|^mais|kokosmilch|ajvar|gewürzgurke|gurkenwasser|gürkchen|apfelmus|marmelade|currypaste|curry paste|pesto|oliven$|kapern|krautsalat|bolognese sauce/],
    ['sauces', /öl$|^öl|sojasauce|sojasoße|sauce|soße|ketchup|senf|sriracha|essig|balsamico|sirup|dicksaft|honig|worcest|teriyaki|barbecue|bbq|austern|mirin|tahini|dressing|süße deiner wahl/],
    ['produce', /zwiebel|knoblauch|lauch|porree|ingwer|chili|paprika|tomate|gurke|salat|spinat|rucola|kohl|brokkoli|blumenkohl|möhre|karotte|kartoffel|drilling|kürbis|zucchini|aubergine|pastinake|rote beete|sellerie|avocado|zitrone|limette|orange|apfel|mango|banane|beere|petersilie|basilikum|koriander$|minze|dill|schnittlauch|kräuter|pak choi|gemüse$|^gemüse|mais ?kolben|frühlingszwiebel/],
  ];

  const aisleOf = (name, unit) => {
    // Soße and Sauce are the same shelf.
    const text = plain(name).replace(LEAD_RE, '').replace(/soße/g, 'sauce');
    if (DRIED_HERBS_RE.test(text)) return FRESH_UNIT_RE.test(plain(unit)) ? 'produce' : 'spices';
    for (const [aisle, re] of RULES) {
      if (re.test(text)) return aisle;
    }
    return 'other';
  };

  // Vorrat by default: spices and baking basics, plus plain cooking oils and salt-and-pepper style rows.
  const PANTRY_EXTRA_RE = /^(öl|olivenöl|rapsöl|sonnenblumenöl|pflanzenöl|neutrales öl|kokosöl|kokosfett|salz und pfeffer|salz pfeffer)$/;
  const isPantryDefault = (name, unit) => aisleOf(name, unit) === 'spices' || PANTRY_EXTRA_RE.test(plain(name));

  // pantry: { have: [keys], buy: [keys] } overrides on top of the default (key = canonical()).
  const inPantry = (name, unit, pantry) => {
    const key = canonical(name);
    if (pantry?.have?.includes(key)) return true;
    if (pantry?.buy?.includes(key)) return false;
    return isPantryDefault(name, unit);
  };

  // ---------- one line per ingredient across units ----------
  // The same ingredient often comes in several units (Spinat 50 g + 6 EL, Petersilie 2 EL + 2 Handvoll,
  // Salz Prise + TL). g, ml, TL, EL, Prise and Handvoll are folded into one line via rough gram weights;
  // Stück / Zehe / Dose / Bund and friends are never converted.
  const HERB_RE = /(petersilie|basilikum|dill|schnittlauch|koriander|minze|kerbel|thymian|rosmarin|salbei|oregano|estragon)/;
  const LEAFY_RE = /(spinat|salat|rucola|mangold|feldsalat|babyspinat|pak choi|grünkohl|kohl)/;
  const unitClass = (unit) => {
    const u = plain(unit).replace(/\./g, '');
    if (u === 'g' || u === 'gramm') return 'g';
    if (u === 'ml' || u === 'milliliter') return 'ml';
    if (u === 'tl' || u === 'teelöffel') return 'tl';
    if (u === 'el' || u === 'esslöffel') return 'el';
    if (u === 'handvoll') return 'handvoll';
    if (/^(prise|prisen|pinch|n geschmack|nach geschmack|etwas)$/.test(u)) return 'taste';
    return '';
  };
  // Grams per unit; herbs and leafy greens are light, everything else is a spoon of something wet or ground.
  const gramsPer = (cls, name) => {
    const text = plain(name);
    const herb = HERB_RE.test(text);
    const leafy = !herb && LEAFY_RE.test(text);
    if (cls === 'g' || cls === 'ml') return 1;
    if (cls === 'tl') return herb ? 1 : leafy ? 3 : 5;
    if (cls === 'el') return herb ? 3 : leafy ? 10 : 15;
    if (cls === 'handvoll') return herb ? 25 : 30;
    return gramsPer('tl', name) / 8; // Prise
  };

  // rows: [{ key, name, unit, raw }] with key = canonical|unit. Returns the same rows with mixed-unit
  // ingredients folded into the dominant unit (metric wins when present, else the unit with most weight).
  const foldUnits = (rows) => {
    const groups = new Map();
    rows.forEach((row) => {
      const cls = unitClass(row.unit);
      if (!cls) return;
      const id = canonical(row.name);
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push({ row, cls });
    });
    const drop = new Set();
    groups.forEach((list) => {
      if (list.length < 2) return;
      const real = list.filter((entry) => entry.cls !== 'taste');
      if (!real.length) {
        // Only Prise / nach Geschmack variants: one line, no amount.
        list.slice(1).forEach((entry) => drop.add(entry.row));
        return;
      }
      const grams = (entry) => entry.row.raw * gramsPer(entry.cls, entry.row.name);
      const metric = real.filter((entry) => entry.cls === 'g' || entry.cls === 'ml');
      const pool = metric.length ? metric : real;
      const target = pool.slice().sort((a, b) => grams(b) - grams(a))[0];
      const total = list.reduce((sum, entry) => sum + (entry.cls === 'taste' ? (entry.row.raw || 1) * gramsPer('taste', entry.row.name) : grams(entry)), 0);
      target.row.raw = total / gramsPer(target.cls, target.row.name);
      list.forEach((entry) => {
        if (entry !== target) drop.add(entry.row);
      });
    });
    return rows.filter((row) => !drop.has(row));
  };

  return { AISLES, plain, canonical, isDropped, aisleOf, isPantryDefault, inPantry, foldUnits };
});
